import { render, staticRenderFns } from "./ProductsTableRow.vue?vue&type=template&id=6b6a8545&scoped=true&"
import script from "./ProductsTableRow.vue?vue&type=script&lang=js&"
export * from "./ProductsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTableRow.vue?vue&type=style&index=0&id=6b6a8545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a8545",
  null
  
)

export default component.exports